import { usePermissionCheck } from "features/common/permissions/usePermissionCheck"
import { ClientAbility, LevelAbility } from "suus-api"
import { Ref } from "vue"

/**
 * Collection of helper functions to check permissions.
 * Functions on this layer of abstraction shouldn't implement much logic.
 * They should just be a wrapper around the usePermissionCheck hook.
 * Implement logic inside the usePermissionCheck hook.
 */

export function useCanSendUrgentOnLevelOrClientFallback(
  levelId?: number
): Ref<boolean> {
  const { hasLevelPermissionOrClientFallback } = usePermissionCheck()
  return hasLevelPermissionOrClientFallback(
    levelId,
    LevelAbility.SendUrgentLevelDigest,
    ClientAbility.SendUrgentDigest
  )
}

export function useCanAccessGroup(): Ref<boolean> {
  const { hasClientPermission } = usePermissionCheck()
  return hasClientPermission(ClientAbility.AccessGroups)
}
